import { Typography } from "@maxhub/max-ui"

export const TypographyDisplayExample = {
    title: 'Typography.Display',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: 'Hello world',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
    ],

    Preview({ props }){
        return (
            <Typography.Display>
                {props.children}
            </Typography.Display>
        )
    },

    getCode(props){
        return `<Typography.Display>
  ${props.children}
</Typography.Display>`
    }

}